module.exports = __webpack_public_path__ + "static/media/p1preview.418e7025.jpg";